import { breakpoints, colors } from '@web-for-marketing/react-ui';

export const subNavigationStyles = {
    subNavigationContainer: {
        backgroundColor: colors.background.white,
        width: '100%',
        boxSizing: 'border-box',
        padding: '2.4rem 0',
        [`@media (max-width: ${breakpoints.md})`]: {
            maxHeight: 'unset',
            borderBottom: 'none',
        },
    },
    subNavigation: {
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        justifyContent: 'center',
        flexWrap: 'nowrap',
        overflowX: 'auto',
        boxSizing: 'border-box',
        maxWidth: 1630,
        margin: '0 auto',
        '@media (max-width: 1679.9px)': {
            paddingLeft: '3.6rem ',
            paddingRight: '3.6rem ',
        },
        [`@media (max-width: ${breakpoints.md})`]: {
            overflowX: 'hidden',
        },
    },
    smallLeftMarginIcon: {
        marginLeft: '0.5rem',
    },
    arrowContainer: {
        margin: '0 1.6rem',
    },
    buttonContainer: {
        margin: '0 .8rem',
    },
    buttonItem: {
        width: '100%',
        padding: '.4rem 2.4rem !important',
        borderRadius: '.8rem',
    },
    buttonDivider: {
        marginRight: '2rem',
        borderLeft: '2px solid #C0CCD8',
        height: '2.6rem',
    },
    iconButtonLinkItemContainer: {
        overflow: 'auto',
        scrollbarWidth: 'none',
        '& > *': {
            whiteSpace: 'nowrap',
        },
    },
    arrowButton: {
        '&:hover': {
            backgroundColor: `${colors.core.cloud} !important`,
            color: colors.text.activeSecondary,
        },
    },
    flipArrow: {
        transform: 'scaleX(-1)',
    },
} as const;
